export const perimeterTranslations: Record<string, Record<string, string>> = {
  NETWORK: { en: 'Network', fr: 'Réseau' },
  SERVERS: { en: 'Servers', fr: 'Serveurs' },
  INTERNAL_APPLICATIONS: {
    en: 'Internal Applications',
    fr: 'Applications Internes',
  },
  DMZ: { en: 'DMZ', fr: 'DMZ' },
  CLOUD_APPLICATIONS: { en: 'Cloud Applications', fr: 'Applications Cloud' },
  PC: { en: 'PC', fr: 'Pc' },
}
export const translatePerimeter = (perimeter: string, lang: string): string => {
  return perimeterTranslations[perimeter]?.[lang] || perimeter
}
export const getToken = () => {
  return localStorage.getItem('token')
}
